// Drawer "Practice" metronome controls: the on/off toggle, a click-volume slider
// (the metronome is the app's only generated sound — MIDI-out is the keyboard's own
// voice), and the count-in beats. Bundled so controls.ts stays under the size cap
// (mirrors buildStaffControls / buildCoachNumFields).

import { checkbox, el, field, fieldWith } from "./dom";

interface MetronomeHandlers {
  onMetronome(on: boolean): void;
  onMetronomeVolume(volume: number): void;
  onCountIn(beats: number): void;
}

interface MetronomeControls {
  /** The drawer rows, in order, to splice into the Practice section. */
  rows: HTMLElement[];
  setEnabled(on: boolean): void;
  setVolume(volume: number): void;
  setCountIn(beats: number): void;
}

export function buildMetronomeControls(h: MetronomeHandlers): MetronomeControls {
  const toggle = checkbox("Metronome (click on beat)");
  toggle.input.onchange = () => h.onMetronome(toggle.input.checked);

  const vol = el<HTMLInputElement>("input", { type: "range", min: "0", max: "100", value: "100" });
  const volLabel = el<HTMLSpanElement>("span", { textContent: "100%" });
  vol.oninput = () => {
    volLabel.textContent = `${vol.value}%`;
    h.onMetronomeVolume(Number(vol.value) / 100);
  };

  const countIn = el<HTMLInputElement>("input", { type: "number", min: "0", max: "8", value: "0" });
  countIn.onchange = () => h.onCountIn(Number(countIn.value));

  return {
    rows: [toggle.wrap, fieldWith("Click volume", vol, volLabel), field("Count-in beats", countIn)],
    setEnabled(on) {
      toggle.input.checked = on;
    },
    setVolume(volume) {
      const pct = Math.round(Math.max(0, Math.min(1, volume)) * 100);
      vol.value = String(pct);
      volLabel.textContent = `${pct}%`;
    },
    setCountIn(beats) {
      countIn.value = String(beats);
    },
  };
}
